/// Shared Turkish labels for backend enum values shown in the UI.
/// Component-level label maps may use their own wording for the values
/// they care about, but must fall back to these helpers so a raw enum
/// value (e.g. `completed`) never reaches the screen.

const LESSON_STATUS_LABELS: Readonly<Record<string, string>> = {
  scheduled: 'Planlandı',
  completed: 'Tamamlandı',
  pending_approval: 'Onay Bekliyor',
  approved: 'Onaylandı',
  cancelled: 'İptal',
};

const ROLE_LABELS: Readonly<Record<string, string>> = {
  super_admin: 'Super Admin',
  gym_admin: 'Salon Yöneticisi',
  trainer: 'Eğitmen',
  student: 'Öğrenci',
};

const TRANSACTION_REFERENCE_LABELS: Readonly<Record<string, string>> = {
  lesson: 'Ders',
  product: 'Ürün',
  payment: 'Ödeme',
  subscription: 'Abonelik',
  admin_adjustment: 'Yönetici düzeltmesi',
  reward: 'Ödül',
  expired: 'Süresi Doldu',
  restored_expired: 'Geri Getirildi',
  freeze: 'Dondurma',
  lesson_timeoff_refund: 'İzin İadesi',
  plan_purchase: 'Paket Satın Alma',
  lesson_delete_refund: 'Ders Silme İadesi',
  sale_correction: 'Satış Düzeltmesi',
  shared_lesson: 'Ortak Paket Dersi',
  shared_refund: 'Ortak Paket İadesi',
  shared_join: 'Ortak Pakete Katılma',
  shared_leave: 'Ortak Paketten Ayrılma',
  shared_merge: 'Ortak Paket Birleştirme',
};

/// Last resort for an unknown value: never show snake_case to users.
function humanize(value: string): string {
  return value.replace(/_/g, ' ');
}

function lookup(map: Readonly<Record<string, string>>, value: string | null | undefined): string {
  if (!value) return '';
  return Object.prototype.hasOwnProperty.call(map, value) ? map[value] : humanize(value);
}

export function lessonStatusLabel(status: string | null | undefined): string {
  return lookup(LESSON_STATUS_LABELS, status);
}

export function roleLabel(role: string | null | undefined): string {
  return lookup(ROLE_LABELS, role);
}

export function transactionReferenceLabel(type: string | null | undefined): string {
  return lookup(TRANSACTION_REFERENCE_LABELS, type);
}
